enum ScreenType {
  APPLY_POINTS="APPLY_POINTS",
  SEARCH_RESORTS="SEARCH_RESORTS",
  SUMMARY_REVIEW="SUMMARY_REVIEW",
  CANCEL_RESERVATION="CANCEL_RESERVATION",
  RESERVATIONS="RESERVATIONS",
  VIEW_RESERVATION="VIEW_RESERVATION",
  TRANSACTION_HISTORY = "TRANSACTION_HISTORY",
  WAITLIST_APPLY_POINTS="WAITLIST_APPLY_POINTS",
  WAITLIST_MANAGEMENT="WAITLIST_MANAGEMENT",
  WAITLIST_SUMMARY_REVIEW = "WAITLIST_SUMMARY_REVIEW",
  WAITLIST_CANCEL_SUMMARY_REVIEW="WAITLIST_CANCEL_SUMMARY_REVIEW",
  ARRIVING_GUEST_INFO = "ARRIVING_GUEST_INFO",
  GUEST_INFO_CONFIRMATION = "GUEST_INFO_CONFIRMATION",
  TRANSFER_POINTS="TRANSFER_POINTS",
  TRANSFER_POINTS_CONFIRMATION="TRANSFER_POINTS_CONFIRMATION",
  HOPPER_HOME="HOPPER_HOME",
};

export {
  ScreenType,
};
